<template>
  <div class="producttypegory" >
    <el-divider content-position="left">会员搜索关键字列表</el-divider>
    <div style="display: flex ;">
      <el-select
        v-model="searchArr.id"
        filterable
        remote
        reserve-keyword
        placeholder="请输入用户名称"
        size="mini"
        clearable
        :remote-method="searchRemoteCftype"
        :loading="searchLoading"
        @change="handleSearchCftype"
      >
        <el-option
          v-for="user in searchUser"
          :key="user.id"
          :label="user.name"
          :value="user.id"
        >
        </el-option>
      </el-select>
      <div style="text-align: right; flex: 1">
      <el-button type="primary" size="mini" @click="$router.go(-1)">返回</el-button>
    </div>
    </div>
    <el-table
      max-height="650"
      :data="keywordsData"
      style="width: 100%; margin-top: 10px"
      border
      size="mini"
      :header-cell-style="{
        background: '#ecf4ff',
        color: '#333',
        fontWeight: '900',
        fontSize: '0.28rem',
      }"
    >
      <el-table-column prop="id" label="ID"> </el-table-column>
      <el-table-column prop="username.name" label="用户名称"></el-table-column>
      <el-table-column prop="location" label="访问的位置"></el-table-column>
      <el-table-column prop="source" label="来源"></el-table-column>
      <el-table-column prop="keyword" label="关键字"></el-table-column>
      <el-table-column prop="number" label="次数"></el-table-column>
      <el-table-column prop="search_at" label="时间"></el-table-column>
    </el-table>
    <div class="block" style="margin-top: 10px; text-align: right">
      <el-pagination
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        layout="sizes, total, prev, pager, next, jumper"
        :total="total"
        :page-sizes="[10, 15, 30, 50, 100]"
        :page-size="typePerPage"
        background
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SearchRecords',
  data () {
    return {

      searchArr: {
        type_id: ''
      },
      npage: 1,
      typePerPage: 10,
      total: null,
      search_user_id: null,
      search_keyword: null,
      keywordsData: [],
      searchUser: [],
      searchLoading: false
    }
  },
  computed: {
    collapse () {
      return this.$store.state.collapse
    }
  },
  mounted () {
    this.loadTable()
  },
  //   watch: {
  //   searcher: function (n, o) {
  //     this.loadTable(n)
  //   }
  // },
  methods: {
    loadTable () {
      this.$axios
        .get('/api/customer/searchrecords', {
          params: {
            page: this.npage,
            perpage: this.typePerPage,
            search_user_id: this.search_user_id,
            search_keyword: this.search_keyword
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.keywordsData = data.data.data
            this.total = data.data.total
            console.log(this.keywordsData)
          }
        })
        .catch()
    },
    handleCurrentChange (val) {
      this.npage = val
      this.loadTable()
    },
    handleSizeChange (val) {
      this.typePerPage = val
      this.loadTable()
    },
    searchRemoteCftype (query) {
      if (query !== '') {
        this.searchLoading = true
        setTimeout(() => {
          this.searchLoading = false
          this.searchItem(query)
        }, 200)
      } else {
        this.searchUser = []
      }
    },
    searchItem (query) {
      this.$axios
        .get('api/customer/getusername', {
          params: {
            search: query
          }
        })
        .then(({ data }) => {
          if (data.code === 1) {
            this.searchUser = data.data
          }
        })
        .catch()
    },
    handleSearchCftype (query) {
      this.search_user_id = query
      setTimeout(() => {
        this.loadTable()
      })
    },
    typeIn () {
      this.typeIndrawer = true
    }
  }
}
</script>

<style  scoped>
.producttypegory {
  /* margin-left: 3.6rem; */
  padding: 1.82rem 0.4rem 0.4rem 0.4rem;
}

</style>



// WEBPACK FOOTER //
// src/pages/my_customers/search_records.vue